import { FunctionComponent } from 'react'
import styled from 'styled-components'

const StyledOuterWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;

  grid-template-columns: auto minmax(0, 1fr);
`
type OuterWrapperProps = {
  children?: React.ReactNode
}

const OuterWrapper: FunctionComponent<OuterWrapperProps> = ({ children }) => {
  return (
    <StyledOuterWrapper className="outerwrapper">{children}</StyledOuterWrapper>
  )
}

export default OuterWrapper
